export const tableColumnList = [
  {
    field: 'exceptionCode', // 1
    title: '异常编号',
    editRender: {
      name: 'exceptionCode',
    },
  },
  {
    field: 'exceptionDescription', // 1
    title: '异常描述',
    editRender: {
      name: 'exceptionDescription',
    },
  },
  {
    field: 'exceptionTypeName',
    title: '异常类型',
    editRender: { name: 'exceptionTypeName' },
  },
  {
    field: 'exceptionReasonName',
    title: '异常原因',
    editRender: {
      name: 'exceptionReasonName',
    },
  },
  {
    field: 'hasExceptionExpense',
    title: '是否有异常费用',
    editRender: {
      name: 'hasExceptionExpense',
    },
  },
  {
    field: 'createByName',
    title: '创建人',
    editRender: {
      name: 'createByName',
    },
  },
  {
    field: 'gmtCreate',
    title: '创建时间',
    editRender: { name: 'gmtCreate' },
  },
  {
    field: 'remarks',
    title: '备注',
    editRender: { name: 'remarks' },
  },
];

export const tableRules = {
  // exceptionDescription: [{ required: true, message: '必填字段' }],
  // exceptionTypeName: [{ required: true, message: '必填字段' }],
  // createByName: [{ required: true, message: '必填字段' }],
  // gmtCreate: [{ required: true, message: '必填字段' }],
  // exchangeRate: [{ required: true, message: '必填字段' }],
  // domesticAmount: [{ required: true, message: '必填字段' }],
  // contractNo: [{ required: true, message: '必填字段' }],
};
